import React from 'react';

const GraphLoader = ({ height = 378 }) => {
    return (
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="mdi mdi-dots-circle mdi-spin text-muted h1 mt-0"></i>
        </div>
    );
};

export default GraphLoader;
